import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=27c84a6a&scoped=true&"
import script from "./TagsView.vue?vue&type=script&lang=ts&"
export * from "./TagsView.vue?vue&type=script&lang=ts&"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=27c84a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c84a6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon})
